import { dmpGenders, dmpSexes, guardianRoles }                     from "./dmpConstants";
import { dmpStatuses, documentFormats, userAuthorizationStatuses } from "./index";

export const remoteSexes = {
  U: dmpSexes.UNKNOWN,
  M: dmpSexes.MALE,
  F: dmpSexes.FEMALE
};

export const remoteGenders = {
  U  : dmpGenders.UNKNOWN,
  M  : dmpGenders.MR,
  Mme: dmpGenders.MRS
};

export const remoteGuardianRoles = {
  NONE   : guardianRoles.GUARDIAN_NONE,
  FTH    : guardianRoles.GUARDIAN_FATHER,
  MTH    : guardianRoles.GUARDIAN_MOTHER,
  STPFTH : guardianRoles.GUARDIAN_STEPFATHER,
  STPMTH : guardianRoles.GUARDIAN_STEPMOTHER,
  GRFTH  : guardianRoles.GUARDIAN_GRANDFATHER,
  GRMTH  : guardianRoles.GUARDIAN_GRANDMOTHER,
  GGRFTH : guardianRoles.GUARDIAN_GREAT_GRANDFATHER,
  GGRMTH : guardianRoles.GUARDIAN_GREAT_GRANDMOTHER,
  AUNT   : guardianRoles.GUARDIAN_AUNT,
  UNCLE  : guardianRoles.GUARDIAN_UNCLE,
  BRO    : guardianRoles.GUARDIAN_BROTHER,
  SIS    : guardianRoles.GUARDIAN_SISTER,
  RESPRSN: guardianRoles.GUARDIAN_GUARDIAN
};

export const remoteDmpStatuses = {
  [dmpStatuses.DMPExist]   : "open",
  [dmpStatuses.DMPIsClosed]: "closed",
  [dmpStatuses.DMPNotFound]: "no-dmp",
  [dmpStatuses.DMPError]   : "error"
};

export const remoteUserAuthorizationStatuses = {
  [userAuthorizationStatuses.AuthorizationError]  : "no",
  [userAuthorizationStatuses.AuthorizationExist]  : "valide",
  [userAuthorizationStatuses.AuthorizationExpired]: "outdated",
  [userAuthorizationStatuses.AuthorizationDenied] : "no",
  [userAuthorizationStatuses.NoAuthorization]     : "no"
};
export const remoteDocumentFormats           = {
  text           : documentFormats.textPlain,
  rtf            : documentFormats.richTextFormat,
  jpeg           : documentFormats.jpeg,
  tiff           : documentFormats.tiff,
  pdf            : documentFormats.pdf,
  vsm            : documentFormats.vsm,
  vsm202201      : documentFormats.vsm202201,
  vsmIps202401   : documentFormats.vsmIps202401,
  dlu            : documentFormats.dlu,
  dlu202201      : documentFormats.dlu202201,
  dluIps202401   : documentFormats.dluIps202401,
  fludr          : documentFormats.fludr,
  fludr202201    : documentFormats.fludr202201,
  fludt          : documentFormats.fludt,
  fludt202201    : documentFormats.fludt202201,
  ldlEes         : documentFormats.ldlEes,
  ldlEes202201   : documentFormats.ldlEes202201,
  ldlSes         : documentFormats.ldlSes,
  ldlSes202201   : documentFormats.ldlSes202201,
  bio            : documentFormats.biologicalReport,
  bio202301      : documentFormats.biologicalReport202301,
  kos            : documentFormats.kos,
  crImg          : documentFormats.crImg,
  daImg          : documentFormats.daImg,
  vaccin         : documentFormats.hv,
  ppsCancer202201: documentFormats.ppsCancer202201,
  ppsCancer      : documentFormats.ppsCancer,
  ppsPaerpa      : documentFormats.ppsPaerpa,
  cseCS8         : documentFormats.cseCS8,
  cseCS9         : documentFormats.cseCS9,
  cseCS24        : documentFormats.cseCS24,
  cseMde         : documentFormats.cseMde,
  vacNote        : documentFormats.vacNote,
  epMedDm        : documentFormats.epMedDm,
  tlmDa          : documentFormats.tlmDa,
  tlmDa202201    : documentFormats.tlmDa202201
};
